export enum LanguageCodes {
  EN = 'EN',
  DE = 'DE',
  FR = 'FR',
  JP = 'JP',
  NL = 'NL',
  PT = 'PT',
  PL = 'PL',
  ES = 'ES',
  IT = 'IT',
  ZH = 'ZH',
  TH = 'TH',
  MS = 'MS',
  VI = 'VI',
  CZ = 'CZ',
  HU = 'HU',
  HI = 'HI'
}

export enum CountryCodes {
  DEU = 'DEU',
  CAN = 'CAN',
  JPN = 'JPN',
  UK = 'UK',
  USA = 'USA',
  NLD = 'NLD',
  FRA = 'FRA',
  IND = 'IND',
  BRA = 'BRA',
  POL = 'POL',
  IRL = 'IRL',
  MEX = 'MEX',
  SGP = 'SGP',
  ITA = 'ITA',
  TWN = 'TWN',
  CHE = 'CHE',
  ESP = 'ESP',
  THA = 'THA',
  MYS = 'MYS',
  VNM = 'VNM',
  CZE = 'CZE',
  HUN = 'HUN',
  HKG = 'HKG'
}
